import { createTheme } from "@mui/material/styles";
import { ThemeOptions } from "@mui/material/styles";
import breakpoints from "./theme/base/breakpoints";
import colors from "./theme/base/colors";
import typography from "./theme/base/typography";
import boxShadows from "./theme/base/boxShadows";
import Shadows from "./theme/base/Shadows";
import borders from "./theme/base/borders";
import globals from "./theme/base/globals";
import boxShadow from "./theme/functions/boxShadow";
import hexToRgb from "./theme/functions/hexToRgb";
import linearGradient from "./theme/functions/linearGradient";
import pxToRem from "./theme/functions/pxToRem";
import rgba from "./theme/functions/rgba";
import container from "./theme/components/container";
import tableHead from "./theme/table/tableHead";
import tableCell from "./theme/table/tableCell";
import button from "./theme/components/button/index";
import buttonText from "./theme/components/button/text"
import iconButton from "./theme/components/iconButton";
import input from "./theme/components//form/input";
import inputLabel from "./theme/components/form/inputLabel";
import inputOutlined from "./theme/components/form/inputOutlined";
import textField from "./theme/components/form/textField";
import textArea from "./theme/components/form/Textarea";
import sidenav from "./theme/components/sidenav";
import list from "./theme/components/list";
import listItem from "./theme/components/list/listItem";
import listItemText from "./theme/components/list/listItemText";
import card from "./theme/components/card";
import cardMedia from "./theme/components/card/cardMedia";
import cardContent from "./theme/components/card/cardContent";
import menu from "./theme/components/menu/index";
import menuItem from "./theme/components/menu/menuItem";
import switchButton from "./theme/components/form/switchButton";
import divider from "./theme/components/divider";
import tableContainer from "./theme/components/table/tableContainer";
import linearProgress from "./theme/components/linearProgress";
import breadcrumbs from "./theme/components/breadcrumbs";
import slider from "./theme/components/slider";
import avatar from "./theme/components/avatar";
import tooltip from "./theme/components/tooltip";
import appBar from "./theme/components/appBar";
//import tabs from "./theme/components/tabs/index";
//import tab from "./theme/components/tabs/tab";
import stepper from "./theme/components/stepper";
import step from "./theme/components/stepper/step";
import stepConnector from "./theme/components/stepper/stepConnector";
import stepLabel from "./theme/components/stepper/stepLabel";
import stepIcon from "./theme/components/stepper/stepIcon";
import select from "./theme/components/form/select";
import formControlLabel from "./theme/components/form/formControlLabel";
import formLabel from "./theme/components/form/formLabel";
import checkbox from "./theme/components/form/checkbox";
import radio from "./theme/components/form/radio";
import autocomplete from "./theme/components/form/autocomplete";
import popover from "./theme/components/popover";
import buttonBase from "./theme/components/buttonBase";
import icon from "./theme/components/icon";
import svgIcon from "./theme/components/svgIcon";
import link from "./theme/components/link";
import dialog from "./theme/components/dialog";
import dialogTitle from "./theme/components/dialog/dialogTitle";
import dialogContent from "./theme/components/dialog/dialogContent";
import dialogContentText from "./theme/components/dialog/dialogContentText";
import dialogActions from "./theme/components/dialog/dialogActions";



interface CustomThemeOptions extends ThemeOptions {
  borders?: {
    borderColor: React.CSSProperties['color'];
    borderWidth?: {
      0: number | string;
      1: number | string;
      2: number | string;
      3: number | string;
      4: number | string;
      5: number | string;
    };
    borderRadius?: {
      xs: number | string;
      sm: number | string;
      md: number | string;
      lg: number | string;
      xl: number | string;
      xxl: number | string;
      section: number | string;
    };
  };
  functions: {
    boxShadow: (offset: any[], radius: any[], color: any, opacity: any, inset?: string) => string;
    hexToRgb: (hex: any) => string;
    linearGradient: (color: any, colorState: any, angle?: number) => string;
    pxToRem: (number: any, baseNumber?: number) => string;
    rgba: (color: any, opacity: any) => string;
  };
}

const setThemeObj = createTheme({
  breakpoints: { ...breakpoints },
  typography: { ...typography },
  palette: { ...colors },
  shadows: Shadows  as any,
  boxShadows: { ...boxShadows } as any,
  border: { ...borders },
  functions: {
    boxShadow,
    hexToRgb,
    linearGradient,
    pxToRem,
    rgba,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        ...container,
      },
    },
    MuiDrawer: { ...sidenav },
    MuiList: { ...list },
    MuiListItem: { ...listItem },
    MuiListItemText: { ...listItemText },
    MuiCard: { ...card },
    MuiCardMedia: { ...cardMedia },
    MuiCardContent: { ...cardContent },
    MuiButton: { ...button },
    MuiButtonText: { ...buttonText },
    MuiIconButton: { ...iconButton },
    MuiInput: { ...input },
    MuiInputLabel: { ...inputLabel },
    MuiOutlinedInput: { ...inputOutlined },
    MuiTextField: { ...textField },
    MuiTextArea: { ...textArea },
    MuiMenu: { ...menu },
    MuiMenuItem: { ...menuItem },
    MuiSwitch: { ...switchButton },
    MuiDivider: { ...divider },
    MuiTableContainer: { ...tableContainer },
    MuiTableHead: { ...tableHead },
    MuiTableCell: { ...tableCell },
    MuiLinearProgress: { ...linearProgress },
    MuiBreadcrumbs: { ...breadcrumbs },
    MuiSlider: { ...slider },
    MuiAvatar: { ...avatar },
    MuiTooltip: { ...tooltip },
    MuiAppBar: { ...appBar },
    //MuiTabs: { ...tabs },
    //MuiTab: { ...tab },
    MuiStepper: { ...stepper },
    MuiStep: { ...step },
    MuiStepConnector: { ...stepConnector },
    MuiStepLabel: { ...stepLabel },
    MuiStepIcon: { ...stepIcon },
    MuiSelect: { ...select },
    MuiFormControlLabel: { ...formControlLabel },
    MuiFormLabel: { ...formLabel },
    MuiCheckbox: { ...checkbox },
    MuiRadio: { ...radio },
    MuiAutocomplete: { ...autocomplete },
    MuiPopover: { ...popover },
    MuiButtonBase: { ...buttonBase },
    MuiIcon: { ...icon },
    MuiSvgIcon: { ...svgIcon },
    MuiLink: { ...link },
    MuiDialog: { ...dialog },
    MuiDialogTitle: { ...dialogTitle },
    MuiDialogContent: { ...dialogContent },
    MuiDialogContentText: { ...dialogContentText },
    MuiDialogActions: { ...dialogActions },
  },
} as CustomThemeOptions); 

export default setThemeObj;